import React, { Component } from "react";
import { Helmet } from "react-helmet";

class PageHelmet extends Component {
  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Zeynel Hotel | Antalya Konyaaltı</title>
          <meta name="description" content="AKDENİZ KONSEPT" />
        </Helmet>
      </React.Fragment>
    );
  }
}

export default PageHelmet;
